module.exports = __webpack_public_path__ + "img/rozlacznik.98e6f14c.jpg";